import { Pipe, PipeTransform } from '@angular/core';
import { Dictionary, filter } from 'lodash';

@Pipe({
  name: 'filter',
  standalone: false,
})
export class FilterPipe implements PipeTransform {
  public transform(items: Dictionary<any> | any[] | null, filterFn: (item: any) => boolean): any {
    return filter(items, filterFn);
  }
}
